import { ApolloProvider } from '@apollo/client';
import { UivBanner } from '@seek/uiv-banner';
import { Routes, Route } from 'react-router-dom';
import { useAppContext } from './context/AppContext';
import type { AppMode } from './context/PricingContextProvider';
import { createHirerGraphClient } from './utils/HirerApolloClient';
import { localizeRoutesForSite } from 'src/routes';
import type { SiteName } from '@seek/melways-sites';
import { useEffect } from 'react';
import { createDatadogLogger } from './utils/datadogRUM/datadogRUM';
import { setLogger } from './utils/logger/logger';
import { HirerAdPriceLookupPage } from './pages/HirerAdPriceLookupPage';

export const Router = () => {
  const { site, environment, buildVersion, branchName } = useAppContext();
  // Typecast here because of a typing mismatch between sku and melways
  const siteRoutes = localizeRoutesForSite(site as SiteName);

  useEffect(() => {
    setLogger(createDatadogLogger({ environment, buildVersion }));
  }, []);

  return (
    <Routes>
      {siteRoutes.map(({ name, route }) => {
        const appMode: AppMode =
          name === 'priceLookupPreview' ? 'PREVIEW' : 'DEFAULT';
        const apolloClient = createHirerGraphClient({
          appMode,
          site,
          environment,
        });

        return (
          <Route
            key={name}
            path={route}
            element={
              <ApolloProvider key={name} client={apolloClient}>
                <UivBanner
                  applicationName="hirer-ad-price-lookup"
                  branch={branchName}
                  version={buildVersion}
                />
                <HirerAdPriceLookupPage appMode={appMode} />
              </ApolloProvider>
            }
          />
        );
      })}
    </Routes>
  );
};
